module.exports = __webpack_public_path__ + "static/media/logo.3f57f644.png";